<script>
export default {
    data() {
        return {
            open: false,
        }
    },
    props: {
        content: Array,
        themeDir: String
    },
    methods: {
        toggleModal() {
            this.open = !this.open;
        }
    },
}
</script>

<style>
    .vue-modal iframe {
        @apply aspect-video rounded-xl shadow-xl bg-white;
        height: auto;
        width: 100%;
    }
</style>

<template>
    <div class='vue-modal'>
        <button class="flex items-center font-bold pt-6" @click="toggleModal">
            <slot name='trigger'></slot>
        </button>

        <div class='fixed inset-0 h-full transition w-full z-[100] bg-white/75 flex justify-center items-center' @click="toggleModal" :class="{
            'opacity-0 invisible': !open,
            'opacity-100 visible': open
        }">
            <div class="max-w-[1024px] w-full relative aspect-video p-4">
                <slot v-if="open"></slot>
                <button @click.stop="() => { this.open = false; }" class='w-10 h-10 rounded-full shadow-lg bg-dark-blue text-sky-50 flex justify-center items-center absolute -top-0 right-0 z-[101]'>
                    <img :src="`${themeDir}/images/close_white_24dp.svg`" class="fill-white" alt="Close" width="24" height="24">
                </button>
            </div>
        </div>
    </div>
</template>
